module.exports = __webpack_public_path__ + "img/outer-ring.4c047ab7.png";